import * as React from "react"
const RtukThirteenAgeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080" {...props}>
    <circle
      cx={540}
      cy={540}
      r={401.71}
      style={{
        fill: "currentColor",
        stroke: "#1d1d1b",
        strokeMiterlimit: 10,
        strokeWidth: "70.75px",
      }}
    />
    <path d="M526.24 652.01c34.61-4.08 77.89-36.51 60.73-75.57-11.55-26.31-40.67-25.1-64.44-19.21-2.81.7-9.93 4.51-11.68 3.26l-16.7-34.89c.63-3.12 47.43-28.24 54.12-32.63 21.79-14.28 33.65-35.79 18.52-60.48-23-37.54-72.44 5.3-89.03 28.58l-2.89.89c-3.98-6.39-30.28-35.68-30.71-40.34-.13-1.41.19-2.09 1.01-3.18 1.83-2.41 15.28-11.59 18.8-14.02 36.7-25.38 99.44-56.2 139.57-22.46 26.88 22.6 39.9 56.09 20.41 88.24-10.43 17.21-27.92 26.76-40.02 42.55 45.66 17.8 81.66 48.63 67.44 102.42-12.14 45.9-71.78 94.41-118.8 97.19-28.74 1.7-59-1.29-87.91.06l-3.65-1.64V653.6l1.59-1.59h83.63ZM420.91 653.07v56.12H234.59v-56.12h70.4l1.59-1.59v-213.9l-1.59-1.59h-74.63V380.4l1.59-1.59H361.1c.19 0 2.65 2.46 2.65 2.65v270.03l1.59 1.59h55.58ZM727.9 629.77c.34-1.04-1.06-2.3-1.06-2.65v-61.95h-62.99l-1.59-1.59v-55.59h64.58v-63.01c0-.35 1.4-1.61 1.06-2.65h54.52l1.59 1.59v62.48l1.59 1.59h62.46l1.59 1.59v52.95c0 .19-2.46 2.65-2.65 2.65h-61.4l-1.59 1.59v61.42l-1.59 1.59H727.9Z" />
  </svg>
)
export default RtukThirteenAgeIcon
